export const STOCK_BRANDS_SET = 'STOCK_BRANDS_SET'
export const STOCK_BRANDS_CATEGORIES_SET = 'STOCK_BRANDS_CATEGORIES_SET'
export const STOCK_BRANDS_FETCHING = 'STOCK_BRANDS_FETCHING'
export const STOCK_BRANDS_UPDATE = 'STOCK_BRANDS_UPDATE'
export const STOCK_BRANDS_ADD = 'STOCK_BRANDS_ADD'